import styled, { css } from 'styled-components';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import media from 'styled-media-query';

const Wrapper = styled.div<{ noMargin: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-size: cover;
  padding-top: 24px;
  ${p =>
    !p.noMargin
      ? css`
          margin-bottom: 32px;
        `
      : undefined};
`;

const Title = styled(Typography)`
  color: #3f3d56 !important;
  margin-bottom: 1rem !important;
  text-align: center;
`;

const Subtitle = styled(Typography)`
  color: #3f3d56 !important;
  text-align: center;
  margin-bottom: 0 !important;
  font-size: 18px !important;
  line-height: 22px !important;
  max-width: 510px;

  ${media.lessThan('small')`
   max-width: 90%;
   font-size: 16px !important;
    `}
`;

type Props = {
  title: string;
  subtitle: string;
  image: string;
  noMargin?: boolean;
};

const InfoBar: React.FC<Props> = ({ title, subtitle, image, noMargin = false }) => {
  return (
    <Wrapper noMargin={noMargin}>
      <Title variant={'h4'}>{title}</Title>
      <Subtitle variant={'h6'}>{subtitle}</Subtitle>
    </Wrapper>
  );
};

export default InfoBar;
